export default "__VITE_ASSET__DC2ySuoy__"